import { Box, Chevron, Popover, Text, useToggle } from '@factorialco/deprecated-design-system'
import moment from 'moment'

import { observer } from 'mobx-react'

import { convertHoursToTimeFormat } from 'modules/core/lib/formatTime'
import i18n from 'modules/core/lib/i18n'

import type Allowance from 'modules/timeoff/store/models/Allowance'

import Outstanding from './Outstanding'
import Total from './Total'
import UsedUntilReferenceDate from './UsedUntilReferenceDate'

interface Props {
  total: number
  outstanding: number
  usedUnitsUntilReferenceDate: number
  allowance: Allowance
  referenceDate: moment.Moment
  isMinuteBlockEnabled?: boolean
}

const TakenTooltip = ({
  total,
  outstanding,
  usedUnitsUntilReferenceDate,
  allowance,
  referenceDate,
  isMinuteBlockEnabled,
}: Props) => {
  const [open, toggle] = useToggle()

  const title = allowance.isDays
    ? i18n.t('time_off.taken_tooltip.taken_days')
    : i18n.t('time_off.taken_tooltip.taken_hours')

  const showUsedUnits =
    usedUnitsUntilReferenceDate > 0 &&
    usedUnitsUntilReferenceDate !== total &&
    +referenceDate.format('Y') - +moment().format('Y') == 0
  const showOutstanding = outstanding > 0

  const formattedTotal =
    isMinuteBlockEnabled && total > 0
      ? convertHoursToTimeFormat(total, false, true)
      : i18n.formatNumber(total)

  const formattedUsedUnitsUntilReferenceDate = isMinuteBlockEnabled
    ? convertHoursToTimeFormat(usedUnitsUntilReferenceDate, false, true)
    : i18n.formatNumber(usedUnitsUntilReferenceDate)

  const formattedOutstanding = isMinuteBlockEnabled
    ? convertHoursToTimeFormat(outstanding, false, true)
    : i18n.formatNumber(outstanding)

  return (
    <Popover.ItemList
      attachment="top center"
      targetAttachment="bottom center"
      toggle={toggle}
      open={open}
      title={title}
    >
      <Box flexDirection="row" alignItems="center">
        <Box alignItems="center" gap="s4">
          <Box flexDirection="row" alignItems="center" gap="s4">
            <Text.Header1>{formattedTotal}</Text.Header1>
            <Chevron direction={open ? 'up' : 'down'} type="quaternary" />
          </Box>
          <Text.Header3>{i18n.t('time_off.taken_stats')}</Text.Header3>
        </Box>
      </Box>
      {showUsedUnits && (
        <UsedUntilReferenceDate
          amount={formattedUsedUnitsUntilReferenceDate}
          referenceDate={referenceDate}
        />
      )}
      {showOutstanding && <Outstanding amount={formattedOutstanding} />}
      <Total amount={formattedTotal} allowance={allowance} />
    </Popover.ItemList>
  )
}

export default observer(TakenTooltip)
